import { lazy } from 'react';
export const LazySubscriptionCanceled = lazy(() => import('@/pages/onboarding/SubscriptionCanceled'));
